<template>
  <div class="relative">
    <h3 class="text-[20px]"
        :class="planNameColor">{{ planName }}</h3>
    <h3 class="flex py-[10px]">
      <div class="text-[32px] font-bold text-cg-black whitespace-nowrap">{{ planCharge }}</div>
      <div class="text-[16px] text-[#A5A6A7] leading-[50px] pl-2 whitespace-nowrap">
        {{ chargePeriod }} &nbsp;
      </div>
    </h3>
    <!-- pc:h-[80px] -->
    <div class="">
      <!-- <h4 v-show="originalServerFee !== ''"
          class="text-[16px] h-5 font-bold text-cg-black">每筆訂單服務費 <span :class="{'line-through':serverFee}">{{originalServerFee}}</span></h4> -->
      <h4 v-show="serverFee !== ''"
          class="mt-2 text-[16px] h-5 font-bold text-cg-black">優惠期間每筆訂單服務費 <span class="text-osn-red-00">{{ serverFee }}</span></h4>
      <!-- <h3 v-show="serverFeeDescription !== ''"
          class="mt-2 text-[14px] h-5 font-bold text-cg-black">
        <span class="text-osn-red-00">*</span>{{ serverFeeDescription }}
      </h3> -->
    </div>

    <!--    <div v-show="serverFee === ''"
             class="h-10"></div>-->

    <div class="my-[10px] lg:my-5 items-center absolute">
      <div v-for="(note, idx) in notes"
           :key="`note-${idx}`"
           v-show="notes !== null">
        <div class="text-left -ml-6 flex items-center">
          <div class="ml-2 mr-2 px-[15px]">
            <!--             <img src="/plan/icon_hint.png" alt="note-icon" /> -->
          </div>
          <div class="pt-[2px] -ml-[16px] text-[12px]"
               :class="note.class">
            {{ note.text }}
          </div>
        </div>
      </div>
    </div>

    <div class="w-full text-center">
      <!-- 雙路 CTA(LN-2):有 lineUrl 時,LINE 主鈕(免費刊登)+ 網頁次連結(保底)。無則維持單鈕。 -->
      <template v-if="lineUrl">
        <a :href="lineUrl"
           target="_blank"
           rel="noopener"
           @click="lineCallback"
           class="flex items-center justify-center w-[100%] lg:max-w-[80%] mx-auto h-[46px] mt-[30px] py-[10px]
             text-[16px] font-bold rounded-full text-cg-black"
           :class="`${buttonColor} ${otherButtonClass}`">{{ buttonText }}
        </a>
        <button type="button"
                @click="webCallback"
                class="inline-block mt-[12px] mb-[32px] text-[19px] text-os-gray-700 underline cursor-pointer">{{ webLabel }}
        </button>
      </template>
      <button v-else
              class="w-[100%] lg:max-w-[80%] h-[46px] mt-[30px] mb-[32px] py-[10px]
        text-[16px] font-bold rounded-full text-cg-black"
              @click="buttonCallback"
              :class="`${buttonColor} ${otherButtonClass}`">{{ buttonText }}
      </button>
    </div>
    <!--     <h4 class="mb-[8px] text-[16px] text-os-gray-700">功能介紹</h4> -->
    <ul class="text-[14px] text-os-gray-700">
      <li :key="idx"
          v-for="(item, idx) in planFeatures"
          class="my-[10px] lg:my-[18px]">
        <div v-if="typeof item === 'string'"
             class="flex h-4">
                     <span class="mr-2">
                      <svg v-show="item!==''"
                           width="24"
                           height="24"
                           viewBox="0 0 24 24"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 12L10.2426 16.2426L18.7279 7.75732"
                              stroke="#6A6A6A"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"/>
                      </svg>
                    </span>
          <div class="font-bold text-[16px] col-span-3">{{ item }}</div>
        </div>
        <div v-else-if="item.value">
          <div class="grid grid-cols-4">
            <div class="font-bold text-[16px] col-span-3">{{ item.name }}</div>
            <div>{{ item.value }}</div>
          </div>
        </div>
        <div v-else
             class="">
          <div class="font-bold text-[16px]">{{ item.name }}</div>
          <div v-if="item.value"> {{ item.value }}</div>
          <ul v-else-if="item.items">
            <li :key="idx"
                v-for="(it, idx) in item.items"
                class="my-[10px] lg:my-[18px]">
              <div v-if="typeof it === 'string'">
                <div class="h-[20px] flex">
                <span v-if="item.hasCheck"
                      class="mr-2">
                  <svg v-if="it.length !== 0"
                       width="24"
                       height="24"
                       viewBox="0 0 24 24"
                       fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L10.2426 16.2426L18.7279 7.75732"
                          stroke="#6A6A6A"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </span>
                  {{ it }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>


    <!--    加購項目-->
    <hr>
    <ul class="text-[14px] text-os-gray-700">
      <li :key="idx"
          v-for="(item, idx) in addOnFeatures"
          class="my-[10px] lg:my-[18px]">
        <div v-if="typeof item === 'string'"
             class="flex h-4">
                     <span class="mr-2">
                      <svg v-show="item!==''"
                           width="24"
                           height="24"
                           viewBox="0 0 24 24"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 12L10.2426 16.2426L18.7279 7.75732"
                              stroke="#6A6A6A"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"/>
                      </svg>
                    </span>
          <div class="font-bold text-[16px] col-span-3">{{ item}}</div>
        </div>
        <div v-else-if="item.value">
          <div class="grid grid-cols-4">
            <div class="font-bold text-[16px] col-span-3">{{ item.name }}</div>
            <div>{{ item.value }}</div>
          </div>
        </div>
        <div v-else
             class="">
          <div class="font-bold text-[20px] text-osn-red-00">*{{ item.name }}</div>
          <div v-if="item.value"> {{ item.value }}</div>
          <ul v-else-if="item.items">
            <li :key="idx"
                v-for="(it, idx) in item.items"
                class="my-[10px] lg:my-[18px]">
              <div v-if="typeof it === 'string'">
                <div class="h-[20px] flex">
                <span v-if="item.hasCheck"
                      class="mr-2">
                  <span v-if="it.length !== 0" class="text-osn-red-00 text-xl">*</span>
<!--                  <svg v-if="it.length !== 0"
                       width="24"
                       height="24"
                       viewBox="0 0 24 24"
                       fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L10.2426 16.2426L18.7279 7.75732"
                          stroke="#6A6A6A"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>-->
                </span>
                  {{ it }}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <a v-if="item.contact"
           class="cursor-pointer text-osn-black-00 underline"
           @click="item.contact">購買版位請聯絡專員</a>
      </li>
    </ul>

  </div>
</template>

<script>
//import { store } from '@/store'

export default {
  name: 'PlanCard',
  props: {
    planName: {
      type: String,
      default: 'Plan Name'
    },
    planId: {
      type: String,
      default: ''
    },
    planCharge: {
      type: String,
      default: 'Plan Charge'
    },
    chargePeriod: {
      type: String,
      default: ''
    },
    originalServerFee: {
      type: String,
      default: '20%'
    },
    serverFee: {
      type: String,
      default: 'Server Fee'
    },
    serverFeeDescription: {
      type: String,
      default: ''
    },
    planFeatures: {
      type: Array,
      default: () => []
    },
    addOnFeatures: {
      type: Array,
      default: () => []
    },
    planNameColor: {
      type: String,
      default: 'text-cg-black'
    },
    buttonColor: {
      type: String,
      default: 'bg-cg-yellow'
    },
    otherButtonClass: {
      type: String,
      default: ''
    },
    notes: {
      type: Array,
      default: null
    },
    buttonText: {
      type: String,
      default: '開始使用'
    },
    buttonCallback: {
      type: Function,
      default: () => {
      }
    },
    // 雙路 CTA(LN-2):lineUrl 非空 → 渲染 LINE 主鈕 + 網頁次連結;空 → 維持單鈕(向下相容)。
    lineUrl: {
      type: String,
      default: ''
    },
    lineCallback: {
      type: Function,
      default: () => {
      }
    },
    webLabel: {
      type: String,
      default: ''
    },
    webCallback: {
      type: Function,
      default: () => {
      }
    }
  },
  data: () => ({
    //...store
  }),
  methods: {},
  components: {}
}
</script>
